import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    changeStatus: false,
};

const inputSlice = createSlice({
    name: 'input',
    initialState,
    reducers: {
        changeStatus(state, action) {
            state.changeStatus = action.payload;
        },
     },
});

export const { changeStatus } = inputSlice.actions;
export default inputSlice.reducer;